module.exports = __webpack_public_path__ + "school1.9522981d.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/school1.png
// module id = NOmL
// module chunks = 0